import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../config/config";
import "./style.css";

function NewsList() {
  const location = useLocation();
  const navigate = useNavigate();
  const [newsItems, setNewsItems] = useState([]);
  const [error, setError] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const { t, i18n } = useTranslation();

  const languageMap = {
    tj: 1,
    ru: 2,
    en: 3,
  };

  const getLanguageCode = (lang) => languageMap[lang] || 2;

  useEffect(() => {
    const langCode = getLanguageCode(i18n.language);

    setError(null);
    axios
      .get(`${API_BASE_URL}/api/events?lang=${langCode}&eventType=1`, {
        headers: {
          accept: "text/plain",
          "api-version": "1.0",
        },
      })
      .then((response) => {
        const filteredNews = response.data.enttities.filter(
          (item) => item.type === 1
        );

        if (filteredNews.length === 0) {
          setError(t("NoAvailable"));
        }

        setNewsItems(filteredNews);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setError(t("fetchError") || "Failed fetching data");
      });
  }, [i18n.language]);

  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  const displayedNews = showAll ? newsItems : newsItems.slice(0, 4);

  return (
    <Container className="p-5">
      <h2 className="mb-3 card-title">{t("news")}</h2>

      {error ? (
        <div className="text-center text-danger py-5">
          <p>{t("NoAvailable")}</p>
        </div>
      ) : (
        <>
          <Row>
            {displayedNews.map((item, index) => (
              <Col
                sm
                lg="3"
                className="pb-5 d-flex"
                key={index}
                data-aos="zoom-in"
              >
                <Card className="w-100 d-flex flex-column">
                  <div className="position-relative">
                    <Card.Img
                      variant="top"
                      src={
                        item.image ||
                        "https://www.imgacademy.com/sites/default/files/styles/scale_1700w/public/2022-07/img-homepage-meta_0.jpg?itok=LMirU0Ik"
                      }
                      alt="News"
                      className="fixed-image"
                    />
                    <div className="date-label position-absolute">
                      {new Date(item.createdDate).toLocaleDateString()}
                    </div>
                  </div>
                  <Card.Body className="d-flex flex-column">
                    <Card.Title
                      style={{ fontSize: "20px" }}
                      className="h5"
                      dangerouslySetInnerHTML={{ __html: item.title }}
                    />
                    <Card.Text
                      className="flex-grow-1"
                      dangerouslySetInnerHTML={{ __html: item.shortDesc }}
                    />
                    <Link
                      to={`/news/show/${item.id}`}
                      className="btn ButtonM w-100 mt-auto"
                    >
                      {t("Read more")}
                    </Link>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          {!showAll && newsItems.length > 4 && (
            <div className="text-center mt-3">
              <button
                className="btn ButtonM"
                onClick={() => {
                  if (location.pathname === "/news") {
                    setShowAll(true);
                  } else {
                    navigate("/news");
                  }
                }}
              >
                {t("seeEveryNews")}
              </button>
            </div>
          )}
        </>
      )}
    </Container>
  );
}

export default NewsList;
